
import { useResourceUsage } from './use-resource-usage';
import { useSubscriptionData } from './use-subscription-data';
import { useAuth } from '@/contexts/AuthContext';

export const useBotDeploymentValidation = () => {
  const { user } = useAuth();
  const { data: subscriptionData } = useSubscriptionData(user?.id);
  const { data: resourceUsage } = useResourceUsage(user?.id);

  const canDeployBot = () => {
    if (!subscriptionData?.package || !resourceUsage) {
      return false;
    }

    return resourceUsage.userBotsCount < subscriptionData.package.max_user_bots;
  };

  const getDeploymentErrorMessage = () => {
    if (!subscriptionData?.package) {
      return 'No active subscription found. Please upgrade to deploy bots.';
    }

    if (resourceUsage && resourceUsage.userBotsCount >= subscriptionData.package.max_user_bots) {
      return `You've reached your limit of ${subscriptionData.package.max_user_bots} bots. Please upgrade your subscription to deploy more bots.`;
    }

    return null;
  };

  return {
    canDeployBot,
    getDeploymentErrorMessage,
    currentCount: resourceUsage?.userBotsCount || 0,
    maxBots: subscriptionData?.package?.max_user_bots || 0
  };
};
